import React, { useState } from 'react';
import { Container, Paper, Typography, Box, Skeleton, Alert } from '@mui/material';
import BuscadorPacientes from './BuscadorPacientes';
import TimelineConsultas from './TimelineConsultas';
import ResumenPaciente from './ResumenPaciente';
import { useTheme } from '@mui/material/styles';
import axios from '../../config/axios';

const ConsultasPacientes = () => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paciente, setPaciente] = useState(null);
  const [casos, setCasos] = useState([]);

  const handleSearch = async (rut) => {
    if (!rut) {
      setError('Por favor ingrese un RUT válido');
      return;
    }

    setIsLoading(true);
    setError(null);
    setPaciente(null);
    setCasos([]);
    
    try {
      console.log('Buscando paciente con RUT:', rut);

      // Buscar paciente por RUT
      const pacienteResponse = await axios.get(`/usuarios/buscar/${rut}`);
      console.log('Paciente encontrado:', pacienteResponse.data);
      
      if (!pacienteResponse.data) {
        throw new Error('No se encontró el paciente');
      }
      
      setPaciente(pacienteResponse.data);

      // Obtener casos del paciente usando query params
      if (pacienteResponse.data._id) {
        const casosResponse = await axios.get('/casos/paciente', {
          params: { pacienteId: pacienteResponse.data._id }
        });
        console.log('Casos del paciente:', casosResponse.data);
        
        if (!Array.isArray(casosResponse.data)) {
          console.error('La respuesta de casos no es un array:', casosResponse.data);
          setCasos([]);
        } else {
          setCasos(casosResponse.data);
        }
      } else {
        console.error('ID de paciente no disponible');
        setError('Error al obtener el historial del paciente');
      }
    } catch (err) {
      console.error('Error completo:', err);
      console.error('Detalles del error:', {
        mensaje: err.message,
        respuesta: err.response?.data,
        status: err.response?.status
      });
      
      if (err.response?.status === 404) {
        setError('No se encontró el paciente con el RUT especificado');
      } else {
        setError(err.response?.data?.error || 'Error al buscar el paciente');
      }
      
      setPaciente(null);
      setCasos([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="lg">
      <Typography variant="h5" component="h2" gutterBottom align="center">
        Consulta de Pacientes
      </Typography>
      
      <Box sx={{ my: 4 }}>
        <BuscadorPacientes onSearch={handleSearch} />
      </Box>

      {error && (
        <Alert severity="error" sx={{ my: 2 }}>
          {error}
        </Alert>
      )}

      {isLoading ? (
        <Box sx={{ my: 4 }}>
          <Skeleton variant="rectangular" height={200} />
        </Box>
      ) : (
        <>
          {paciente && (
            <Box sx={{ my: 4 }}>
              <ResumenPaciente paciente={paciente} casos={casos} />
            </Box>
          )}
          
          {paciente && casos.length > 0 && (
            <Box sx={{ my: 4 }}>
              <TimelineConsultas casos={casos} />
            </Box>
          )}
        </>
      )}
    </Container>
  );
};

export default ConsultasPacientes; 